import { ResumeMainPage } from '../ResumeMainPage'
import { Box } from '@mui/material'

export function ProgrammingLanguagePage() {
    return (
        <ResumeMainPage index="Programming_Language">
            <Box>Reserved for natural language.</Box>
        </ResumeMainPage>
    )
}
